const moment = require('moment');
import vegas from 'vegas';

/**
 * 単純なサンプル
 * moment.jsを使って現在日付をconsole出力するだけ
 */
$(function () {
    console.log(moment().format("YYYY-MM-DD"));
    $("#TopPageMainImage").vegas({
        slides: [
            { src: "assets/img/Slide/Photo1.jpg" },
            { src: "assets/img/Slide/Photo2.jpg" },
            { src: "assets/img/Slide/Photo3.jpg" },
            { src: "assets/img/Slide/Photo4.jpg" }
        ],
        timer: false
    });
});
